import NextLink from 'next/link'

import { Avatar } from '@wartek-id/avatar'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { useSETrackEvent } from 'app/Homepage/hooks/useSETrackEvent'
import { useAuth } from 'utils/auth'

const UserProfile = () => {
  const { session } = useAuth()
  const { SETrackClickViewProfile } = useSETrackEvent()
  const email = session.user?.loginEmail ?? session.user?.email

  return (
    <>
      <div className="px-4 bg-white">
        <div className="flex items-center space-x-4 border-b border-[#D9DBDD] py-5">
          <div>
            <Avatar
              src={session.user.picture}
              name={session.user.name}
              size="xxl"
              alt="User Picture"
            />
          </div>
          <div className="w-[calc(100%-80px)]">
            <Text
              data-testid="account-name"
              variant="heading-md"
              className="!font-semibold mb-[2px] break-words"
            >
              {session.user.name}
            </Text>
            <Text
              data-testid="account-email"
              variant="body-sm"
              color="disabled"
              className="mb-2 break-all"
            >
              {email}
            </Text>

            <NextLink href={`/profil/${session.user.id}?from=/akun`} passHref>
              <Button
                data-testid="account-profile-entry"
                color="white"
                size="sm"
                className="space-x-1"
                onClick={SETrackClickViewProfile}
              >
                <span>Lihat profil saya</span>
                <Icon fontSize="small">arrow_forward</Icon>
              </Button>
            </NextLink>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserProfile
